import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Injectable()
export class RouterService {
    private previousUrls: string[] = [];

    private currentUrl: string;
    private addCurrentToPrevious = true;
    private addNextPageToRouteStack = true;

    constructor(public router: Router) {
        router.events.subscribe(e => {
            if (e instanceof NavigationEnd) {
                if (this.addCurrentToPrevious && this.currentUrl) {
                    this.previousUrls.push(this.currentUrl);
                } else {
                    this.addCurrentToPrevious = true;
                }

                if (this.addNextPageToRouteStack) {
                    this.currentUrl = router.url.toString();
                } else {
                    this.currentUrl = undefined;
                    this.addNextPageToRouteStack = true;
                }
            }
        });
    }

    doNotAddCurrentPageToRouteStack() {
        this.addNextPageToRouteStack = false;
    }

    goBack(defaultUrl: string) {
        this.addCurrentToPrevious = false;

        if (this.previousUrls.length === 0) {
            this.router.navigateByUrl(defaultUrl);
        } else {
            var url = this.previousUrls.pop();
            this.router.navigateByUrl(url);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/routerService.ts